module.exports = __webpack_public_path__ + "static/media/introduction2.1e6b9685.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/introduction2.jpg
// module id = 78
// module chunks = 0